// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"bd5beb91","511":"2a42c697"}[chunkId] + ".chunk.js";
};